import { render, staticRenderFns } from "./EnacAtplDashboardLearnerCardProfile.vue?vue&type=template&id=4225a608"
import script from "./EnacAtplDashboardLearnerCardProfile.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardLearnerCardProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports